import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable } from 'rxjs';

import { ExternalPaymentOption } from '../../.types/interfaces/external-payment-option';

@Injectable({ providedIn: 'root' })
export class ExternalPaymentOptionService {
  public externalPaymentOptions: ExternalPaymentOption[] = [];

  constructor(private http: HttpClient) {
  }

  validateRoutingNumber(routingNumber:string):Observable<any[]>{
    
    // this is a free API to check if a routing number is valid. We get 1000 hits per month which should be ok for now.
    const headers = new HttpHeaders({
      'X-Api-Key': 'Lugz50c9gJeJjWY8XVQC1Q==XwKcXgpmYcjR1zXz'
    });

    const url = `https://api.api-ninjas.com/v1/routingnumber?routing_number=${routingNumber}`;

    return this.http.get<any[]>(url, { headers }).pipe(
      catchError((err: HttpErrorResponse) => {
        const apiMsg =
          typeof err.error === 'string'
            ? err.error
            : err.error?.message || err.error?.error;
  
        const normalized = {
          status: err.status,
          message: apiMsg || err.statusText || err.message || 'Request failed.',
          raw: err
        };
  
        return throwError(() => normalized);
      })
    );
  }

  loadExternalPaymentOptionsObservable(username: string): Observable<any[]> {
    const params = new HttpParams()
        .set('username', username);

    const results = this.http.get<any[]>('/api/externalpaymentoptions', {params: params});

    return results;
  }

  deleteExternalPaymentOption(externalPaymentOptionId: number) {        
    return this.http.delete<any[]>(`/api/externalpaymentoptions/${externalPaymentOptionId}`);
  } 

  createExternalPaymentOption(externalPaymentOption: any): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const jsonExternalPaymentOption = JSON.stringify(externalPaymentOption);

    const results = this.http.post<any[]>('/api/externalpaymentoptions', jsonExternalPaymentOption, httpOptions);

    return results;
  }

  updateExternalPaymentOption(externalPaymentOption: any): Observable<any[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    const jsonExternalPaymentOption = JSON.stringify(externalPaymentOption);

    const results = this.http.put<any[]>('/api/externalpaymentoptions', jsonExternalPaymentOption, httpOptions);

    return results;
  }

  public reset() {
    this.externalPaymentOptions = [];
  }
}